import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import Select from "react-select";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addQuestionnaireText, editQuestionnaireText } from "store/actions";
import { fetchQuestionList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const MailSendModel = props => {
    const { modal, toggle, isEdit, itemData, fetchQuestionnaireTextListData } = props
    const [questionnaireTextData, setQuestionnaireTextData] = useState();
    const [questionList, setQuestionList] = useState()
    const { state } = useLocation();

    const { error, success, loading } = useSelector(state => ({
        loading: state.Questionnaire.loading,
        error: state.Questionnaire.error,
        success: state.Questionnaire.success,
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setQuestionnaireTextData(itemData)
    }, [itemData])

    // fetch language
    const fetchQuestionLists = async () => {
        try {
            const listQuestion = await fetchQuestionList();
            setQuestionList(listQuestion?.data)
        } catch (error) {

        }

    }

    useEffect(() => {
        fetchQuestionLists()
    }, [])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            question_id: questionnaireTextData?.question_id || ''
        },
        validationSchema: Yup.object({
            // question_id: Yup.string().required(props.t("Please Enter Question")),
        }),
        onSubmit: (values, { resetForm }) => {
            toastr.error("Work in progress")
            return

            dispatch(addQuestionnaireText(values, props?.router?.navigate, (res) => {
                if (res?.status === 'success') {
                    
                    resetForm({
                        questionnaire_id: '',
                        is_active: ''
                    });
                    fetchQuestionnaireTextListData()
                    toastr.success(res.message)
                    setSelectValue()
                    toggle()
                } else {
                    toastr.error(res?.message || "Something Went Wrong.")
                    setSelectValue()
                    toggle()
                    
                }
            }));
        }
    });
    const [options, setoptions] = useState([]);
    const [selectValue, setSelectValue] = useState()

    useEffect(() => {
        if (isEdit) {
            setSelectValue(
                {
                    value: questionnaireTextData?.question_id,
                    label: questionnaireTextData?.question,
                }
            )
        }
        let modifiedList = questionList?.map(dky => ({
            value: dky.id,
            label: dky.question,
        }))
        setoptions(modifiedList)
    }, [questionList, questionnaireTextData])
    const handleSelectChange = (obj) => {
        setSelectValue(obj)
    }


    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    setSelectValue()
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        setSelectValue()

                    }}>
                    { props.t("Send Mail")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Type")}:</Label>

                            <Input
                                type="select"
                                name="question_type"
                                value={validation.values.question_type || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.question_type && validation.errors.question_type ? true : false}
                            >
                                <option value="" disabled>{props.t("Invitation Type")}</option>
                                <option value="invitation">{props.t("Invitation")}</option>
                                <option value="reminder">{props.t("Reminder")}</option>
                            </Input>

                            {validation.touched.question_type && validation.errors.question_type ? (
                                <FormFeedback type="invalid">{validation.errors.question_type}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Batch Name")}:</Label>
                            <Select
                                className="custom-select-search-option"
                                options={options}
                                value={selectValue}
                                name="question_id"
                                onChange={handleSelectChange}
                            />
                        </div>

                        {
                            loading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Send")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Send")}
                                    </button>
                                </div>
                        }

                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


MailSendModel.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(MailSendModel);
